export const ONBOARDING_ROUTES = {
  states: '/onboarding/states',
  categories: '/onboarding/exam-categories',
  exams: '/onboarding/favorite-exams',
};
